import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const EventPopupInputComponent = ({ min, max, field, onChange, label, name, type }) => {
  const className = field !== '' ? 'form-control dirty-field' : 'form-control';

  return (
    <div className="full-width">
      <label className="field-label" htmlFor={name}>
        {label}
      </label>
      {type === 'date' ? (
        <DatePicker
          className={className}
          dateFormat="MM/DD/YYYY"
          dropdownMode="select"
          id={name}
          maxDate={max}
          minDate={min}
          onChange={date => {
            onChange(date, name);
          }}
          selected={field}
          showMonthDropdown
          showYearDropdown
        />
      ) : (
        <input
          className={className}
          id={name}
          max={max}
          min={min}
          name={name}
          onChange={event => {
            onChange(event.target.value, name);
          }}
          type={type}
          value={field}
        />
      )}
    </div>
  );
};

EventPopupInputComponent.propTypes = {
  field: PropTypes.string,
  label: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
};

/** Event popup input component. */
export const EventPopupInput = memo(EventPopupInputComponent);
